import PropTypes from 'prop-types';
import {ThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {blue, brown} from '@material-ui/core/colors';

const productionTheme = createMuiTheme({
  palette: {
    primary: blue,
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
    },
  },
});
const sandboxTheme = createMuiTheme({
  palette: {
    primary: brown,
    secondary: {main: '#219e8f'},
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
    },
  },
});

function Theme(props) {
  const {children} = props;

  return (
    <ThemeProvider
      theme={
        process.env.REACT_APP_SANDBOX === 'true'
          ? sandboxTheme
          : productionTheme
      }
    >
      {children}
    </ThemeProvider>
  );
}

Theme.propTypes = {
  children: PropTypes.element.isRequired,
};
export default Theme;
